import React from "react";
import MasterLegalEntityTable from "./view/MasterLegalEntityTable";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
import { PERMISSIONS } from "../../../PermissionsConstants";

const MasterLegalEntity = () => {
  const viewBusinessTypePermission =
    PERMISSIONS.permission_utilities_configureagreement_businesstype_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <div>
      {userPermissions.includes(viewBusinessTypePermission) && (
        <MasterLegalEntityTable />
      )}
    </div>
  );
};

export default MasterLegalEntity;
